// =============================================================================
//  Copyright : 2020 semantics GmbH
//  Date      : $Date: 2024-11-29 17:06:17 +0100 (Fri, 29 Nov 2024) $
//  Author    : Dirk Rothe
//  Worker    : $Author: d.rothe $
//  Revision  : $Rev: 147884 $
//  Purpose   : domain label
// =============================================================================
// ---Third-party imports
import React from 'react'

// ---Framework imports
import log from 'uix/logging'
import {Actions, Sel} from 'uix/registries'
import {useSelector} from 'uix/hooks'
import {Link} from 'uix/components'

// ---Local imports
import {DomainIcon} from './icon'

// ---Globals
export const DomainLabel = ({
  odid,
  dname,
  link, // build link to domain
  shorten = false,
  basic = false,
  shortform = false,
  nameSuffix = false,
  as = 'span', // or div
  style,
}) => {
  let domains = useSelector(Sel.domains)
  if (odid !== undefined) {
    dname = domains.odid2name[odid]
  }
  let ddata = domains.data[dname] ?? {description: 'unk'}
  let cut = s => (s.length > shorten ? `${s.slice(0, shorten)}...` : s)
  let description = ddata.description
  if (shorten) {
    description = cut(description)
  }
  let text = shortform ? ddata.routingPrefix || ddata.name : description

  let linkProps = {}
  if (link) {
    as = Link
    linkProps = {dname, lazy: true}
  }

  return React.createElement(as, {
    style,
    title: ddata.description || ddata.name,
    children: (
      <>
        {!basic && <DomainIcon dname={dname} />}
        {text}
        {nameSuffix && ` (${dname})`}
      </>
    ),
    ...linkProps,
  })
}
